import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { magpCMSApi, post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { useDocumentDetails } from "../../../ApprovalManagement/Drilldown.Hooks";
import { useVendorManagement } from "../Manual.hook";
import { fields } from "../manualConstants";
import { VendorManagementProcessFlowChart } from "./VendorManagementProcessFlowChart";
export const VendorManagement: React.FC = (): JSX.Element => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [tabsData, setTabsData] = useState<any[]>([]);
  const [subTabsData, setSubTabsData] = useState<any[]>([]);
  const [listId, setListId] = useState("");
  const [toggleId, setToggleId] = useState("");
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const {
    data: vendorManagementData,
    isLoading: isLoadingvendorManagement,
    refetch: refetchData,
  } = useVendorManagement(listId || "48", toggleId || "136");
  const {
    data: vendorManagementDataById,
    isLoading: isLoadingManualvendorManagementById,
    refetch: refetchDataById,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (approveId) {
      return;
    }

    const thirdChildActiveTab = query.get("thirdChildActiveTab");

    if (query.get("activeTab") === "vendorManagement" && query.get("subActiveTab") === "vendorRegistration") {
      navigate(
        `/dedicated/magp/manual?activeTab=vendorManagement&subActiveTab=vendorRegistration&thirdChildActiveTab=${
          thirdChildActiveTab ?? "vendorRegistrationOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "vendorRegistrationOverview") {
        setListId("48");
        setToggleId("136");
      } else if (thirdChildActiveTab === "vendorRegistrationPolicies") {
        setListId("48");
        setToggleId("137");
      } else if (thirdChildActiveTab === "vendorRegistrationProcessFlowChartRenewal") {
        setListId("48");
        setToggleId("138");
      } else if (thirdChildActiveTab === "vendorRegistrationProcessFlowChartNewRegistration") {
        setListId("48");
        setToggleId("250");
      } else {
        setListId("43");
        setToggleId("136");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "vendorManagement" && query.get("subActiveTab") === "potentialVendorScreening") {
      navigate(
        `/dedicated/magp/manual?activeTab=vendorManagement&subActiveTab=potentialVendorScreening&thirdChildActiveTab=${
          thirdChildActiveTab ?? "potentialVendorScreeningOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "potentialVendorScreeningOverview") {
        setListId("49");
        setToggleId("162");
      } else if (thirdChildActiveTab === "potentialVendorScreeningPolicies") {
        setListId("49");
        setToggleId("163");
      } else if (thirdChildActiveTab === "potentialVendorScreeningProcessFlowChart") {
        setListId("49");
        setToggleId("164");
      } else {
        setListId("49");
        setToggleId("162");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "vendorManagement" && query.get("subActiveTab") === "vendorPerformanceManagement") {
      navigate(
        `/dedicated/magp/manual?activeTab=vendorManagement&subActiveTab=vendorPerformanceManagement&thirdChildActiveTab=${
          thirdChildActiveTab ?? "vendorPerformanceManagementOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "vendorPerformanceManagementOverview") {
        setListId("50");
        setToggleId("165");
      } else if (thirdChildActiveTab === "vendorPerformanceManagementPolicies") {
        setListId("50");
        setToggleId("166");
      } else if (thirdChildActiveTab === "vendorPerformanceManagementProcessFlowChartUnscheduled") {
        setListId("50");
        setToggleId("167");
      } else if (thirdChildActiveTab === "vendorPerformanceManagementProcessFlowChartSchedule") {
        setListId("50");
        setToggleId("251");
      } else {
        setListId("50");
        setToggleId("165");
      }
      // refetchData();
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);

  useEffect(() => {
    refetchData();
  }, []);
  useEffect(() => {
    if (listId && toggleId) {
      refetchData();
    }
  }, [listId, toggleId]);
  useEffect(() => {
    if (query?.get("id")) {
      refetchDataById();
    }
  }, [query?.get("id")]);

  const VendorManagementFormConfig: FormConfig = {
    initialValues: {
      title: vendorManagementDataById?.payload
        ? decodeHTML(vendorManagementDataById?.payload?.title)
        : decodeHTML(vendorManagementData?.[0]?.title),
      field_vendor_management_desc_en: vendorManagementDataById?.payload
        ? decodeHTML(vendorManagementDataById?.payload?.field_vendor_management_desc_en?.value)
        : decodeHTML(vendorManagementData?.[0]?.field_vendor_management_desc_en),
      field_vendor_management_desc_ms: vendorManagementDataById?.payload
        ? decodeHTML(vendorManagementDataById?.payload?.field_vendor_management_desc_ms?.value)
        : decodeHTML(vendorManagementData?.[0]?.field_vendor_management_desc_ms),
      field_vendor_management_desc_zh: vendorManagementDataById?.payload
        ? decodeHTML(vendorManagementDataById?.payload?.field_vendor_management_desc_zh?.value)
        : decodeHTML(vendorManagementData?.[0]?.field_vendor_management_desc_zh),
      field_vendor_video_url: vendorManagementDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: vendorManagementDataById?.payload?.field_vendor_video_url,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: vendorManagementData?.[0]?.field_vendor_video_url,
            },
          ]),
      field_vendor_details_web_image: vendorManagementDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_procure_details_web_image.png",
              status: "done",
              url: vendorManagementDataById?.payload?.field_vendor_details_web_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_procure_details_web_image.png",
              status: "done",
              url: vendorManagementData?.[0]?.field_vendor_details_web_image,
            },
          ]),
      field_vendor_web_flowchart_image: vendorManagementDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_vendor_web_flowchart_image.png",
              status: "done",
              url: vendorManagementDataById?.payload?.field_vendor_web_flowchart_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_vendor_web_flowchart_image.png",
              status: "done",
              url: vendorManagementData?.[0]?.field_vendor_web_flowchart_image,
            },
          ]),
    },
    fields: fields.vendorManagement,
  };

  useEffect(() => {
    const fetchTabsData = async () => {
      try {
        const response = await magpCMSApi.get(`/api/vendor-management-list/all-fields`);
        const tabData = response.data.map((tab: any) => {
          const listId = tab?.id;
          const label = tab?.field_vendor_process_name_en.replace(/^\d+\.\d+\s*/, "");
          let key = label.replace(/\s+/g, "").replace(/\s[a-z]/g, (match: any) => match.trim().toUpperCase());
          key = key.charAt(0).toLowerCase() + key.slice(1);
          return { listId, label, key };
        });
        // tabData.push({
        //   listId: "",
        //   label: "Process Flow Chart",
        //   key: "vendorManagementProcessFlowChart"
        // });

        setTabsData(tabData);
      } catch (error) {}
    };

    fetchTabsData();

    const subActiveTab = query.get("subActiveTab") ?? "vendorRegistration";
    const listId =
      subActiveTab === "vendorRegistration" ? "48" : subActiveTab === "potentialVendorScreening" ? "49" : "50";

    fetchSubTabsData(subActiveTab, listId);
  }, []);

  useEffect(() => {
    if (vendorManagementDataById !== undefined && !isLoadingvendorManagement) {
      const urlParams = new URLSearchParams(window.location.search);
      const subActiveTab = urlParams.get("subActiveTab") || "businessCase";
      const selectedTab = tabsData.find((tab) => tab.key === subActiveTab);
      if (selectedTab !== undefined) {
        fetchSubTabsData(subActiveTab, selectedTab.listId);
      }
    }
  }, [vendorManagementDataById, tabsData, isLoadingvendorManagement]);

  const fetchSubTabsData = async (activeKey: string, listId: string) => {
    if (!listId) {
      return;
    }
    try {
      const response = await magpCMSApi.get(`/api/vendor-management-topbar-toggle/all-fields?listId=${listId}`);
      const subTabData = response.data.map((subTab: any) => ({
        toggleId: subTab.id,
        listId: subTab.field_procurement_list_reference,
        label: subTab.name,
        key: `${activeKey}${subTab.name
          .replace(/\s+/g, "")
          .replace(/\s[a-z]/g, (match: any) => match.trim().toUpperCase())
          .replace(/[^a-zA-Z0-9]/g, "")}`,
      }));

      // setSubTabsData((prevData:any) => ({
      //   ...prevData,
      //   [listId]: subTabData,
      // }));
      setSubTabsData(subTabData);
    } catch (error) {}
  };
  const handleTabChange = (activeKey: string) => {
    const selectedTab = tabsData.find((tab) => tab.key === activeKey);
    if (selectedTab) {
      fetchSubTabsData(activeKey, selectedTab.listId);
      navigate(`${window.location.pathname}?activeTab=vendorManagement&subActiveTab=${activeKey}`);
    }
  };

  const handleSubTabChange = (listId: string, activeKey: string) => {
    setListId(listId);
    const subTab = subTabsData.find((subTab) => subTab.key === activeKey);
    if (subTab) {
      setToggleId(subTab.toggleId);
    }
    navigate(
      `${window.location.pathname}?activeTab=vendorManagement&subActiveTab=${query?.get(
        "subActiveTab"
      )}&thirdChildActiveTab=${activeKey}`
    );
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
      "field_vendor_details_web_image",
      "field_vendor_video_url",
      "field_vendor_web_flowchart_image",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "MAGP");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else {
            data[key] = data[key][0].url;
          }
        }
      } catch (error) {}
    }

    let descKeys: any = [
      "field_vendor_management_desc_en",
      "field_vendor_management_desc_ms",
      "field_vendor_management_desc_zh",
    ];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }
    const payload = {
      action: action,
      method: method,
      module: "Manual",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}_${query?.get("thirdChildActiveTab")}`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        // id: data?.id,
        field_vendor_list_parent_id: vendorManagementData?.[0]?.field_vendor_list_parent_id || listId,
        field_vendor_manage_toggle_refer: vendorManagementData?.[0]?.field_vendor_manage_toggle_refer || toggleId,
        ...data,
        published: true,
        // createdAt: "2024-07-16T07:44:25",
        // updatedAt: "2024-07-16T07:44:30",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const superSubChildItems = tabsData.map((tab: any) => {
    // const isProcessFlowChartTab = tab.key === "vendorManagementProcessFlowChart";
    //
    return {
      label: tab.label,
      key: tab.key,
      children: (
        <Tabs
          activeKey={query?.get("thirdChildActiveTab") || ""}
          items={subTabsData.map((subTab: any) => {
            const processFlowChartTab: any[] = [
              "vendorPerformanceManagementProcessFlowChartSchedule",
              "vendorPerformanceManagementProcessFlowChartUnscheduled",
              "potentialVendorScreeningProcessFlowChart",
              "vendorRegistrationProcessFlowChartNewRegistration",
              "vendorRegistrationProcessFlowChartRenewal",
              "vendorManagementProcessFlowChart",
            ];
            const isProcessFlowChartTab = processFlowChartTab.includes(subTab.key);

            return {
              label: subTab.label,
              key: subTab.key,
              children: isProcessFlowChartTab ? (
                <>
                  <DynamicForm
                    isLoading={isLoadingManualvendorManagementById || isLoadingvendorManagement}
                    config={VendorManagementFormConfig}
                    onSubmit={(data, buttonValue, reviewNotes) =>
                      onSubmit(
                        data,
                        `${magpHost}/api/vendor-management-details/${vendorManagementData?.[0]?.id}`,
                        "UPDATE",
                        "PATCH",
                        buttonValue == "save" ? "DRAFT" : "PENDING",
                        reviewNotes
                      )
                    }
                  />
                  <VendorManagementProcessFlowChart
                    listId={listId}
                    toggleId={toggleId}
                  />
                </>
              ) : (
                <DynamicForm
                  isLoading={isLoadingManualvendorManagementById || isLoadingvendorManagement}
                  config={VendorManagementFormConfig}
                  onSubmit={(data, buttonValue, reviewNotes) =>
                    onSubmit(
                      data,
                      `${magpHost}/api/vendor-management-details/${vendorManagementData?.[0]?.id}`,
                      "UPDATE",
                      "PATCH",
                      buttonValue == "save" ? "DRAFT" : "PENDING",
                      reviewNotes
                    )
                  }
                />
              ),
            };
          })}
          onChange={(activeKey: any) => handleSubTabChange(tab.listId, activeKey)}
        />
      ),
    };
  });

  if (isLoadingManualvendorManagementById || isLoadingvendorManagement) {
    return <Loader />;
  }

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={superSubChildItems}
      onChange={handleTabChange}
    />
  );
};
